/* Thanksgiving cart drawer helpers v9.2 (draft): instant unlock message + pumpkin rain. Reads DOM only; never calls the cart API. */
(function () {
  'use strict';
  var PUMPKIN = (function () { try { var s = document.currentScript && document.currentScript.src; return s ? s.split('?')[0].replace(/thanksgiving-cart\.js$/, 'tg_pumpkin_orange.png') : ''; } catch (e) { return ''; } })();
  if (window.__tgCartInit) return; window.__tgCartInit = true;
  var SEL_MSG = '[data-essential-cart-element="reward-progress-text"]';
  var OPT_TEXT = '\uD83C\uDF89 You unlocked 10% OFF!';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastRain = 0, lastState = null, optTimer = null;

  function log() { try { if (window.__tgDebug) console.log.apply(console, ['[tg]'].concat([].slice.call(arguments))); } catch (e) {} }
  function q(s, r) { return (r || document).querySelector(s); }
  function msgEl() { return q(SEL_MSG); }
  function realText(el) {
    if (!el) return '';
    var c = el.querySelectorAll('[data-essential-cart-element="reward-progress-text-content"]'), layer = null;
    for (var i = 0; i < c.length; i++) { if (!c[i].closest('[aria-hidden="true"]')) { layer = c[i]; break; } }
    return ((layer || el).textContent || '').replace(/\s+/g, ' ').trim();
  }
  function isUnlocked(t) { return /unlocked|已解锁|已解鎖/i.test(t); }
  function money(t) {
    var m = String(t || '').match(/\$\s*([\d.,]+)/g);
    return m ? m.map(function (x) { return parseFloat(x.replace(/[^\d.]/g, '').replace(/\.$/, '')); }) : [];
  }
  function panel() {
    var h = q('#cart-drawer [data-essential-cart-element="cart-drawer-header"]') || q('[data-essential-cart-element="cart-drawer-header"]');
    return h ? h.parentElement : null;
  }
  function rain() {
    var now = Date.now();
    if (reduce || now - lastRain < 12000) return;
    lastRain = now;
    var pn = panel(); if (!pn) return;
    var box = document.createElement('div');
    box.className = 'tg-pumpkin-rain'; box.setAttribute('aria-hidden', 'true');
    if (getComputedStyle(pn).position === 'static') pn.style.position = 'relative';
    box.style.setProperty('--tg-fall', (pn.clientHeight + 60) + 'px');
    var n = 14;
    var kinds = [], np = PUMPKIN ? n / 2 : 0;
    for (var k = 0; k < n; k++) kinds.push(k < np ? 'p' : 'l');
    for (var k2 = kinds.length - 1; k2 > 0; k2--) { var r2 = Math.floor(Math.random() * (k2 + 1)), t2 = kinds[k2]; kinds[k2] = kinds[r2]; kinds[r2] = t2; }
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span');
      if (kinds[i] === 'p') { var im = document.createElement('img'); im.src = PUMPKIN; im.alt = ''; im.className = 'tg-pumpkin-img'; s.appendChild(im); s.className = 'tg-p'; }
      else { s.textContent = '\uD83C\uDF42'; s.className = 'tg-l'; }
      s.style.left = (Math.random() * 92) + '%';
      s.style.fontSize = (24 + Math.random() * 12).toFixed(0) + 'px';
      s.style.animationDelay = (Math.random() * 2.0).toFixed(2) + 's';
      s.style.animationDuration = (6.0 + Math.random() * 2.0).toFixed(2) + 's';
      s.style.setProperty('--tg-rot', ((Math.random() * 80) - 40).toFixed(0) + 'deg');
      box.appendChild(s);
    }
    pn.appendChild(box);
    log('rain', n);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 11000);
  }
  var opt = null; /* { from: app text at press, at: ms, answered: ms|0 } while an optimistic unlock awaits the server */
  function discApplied() { /* the real automatic discount is in the cart: Savings row with a "10% off" tag */
    var t = document.querySelectorAll('#cart-drawer [data-essential-cart-element="discount-code-tag"], [data-essential-cart-element="discount-code-row"] [data-essential-cart-element="discount-code-tag"]');
    for (var i = 0; i < t.length; i++) if (/10\s*%\s*off/i.test(t[i].textContent || '')) return true;
    return false;
  }
  function setUnlocked(un) {
    var h = document.documentElement;
    if (un !== h.hasAttribute('data-tg-unlocked')) { if (un) h.setAttribute('data-tg-unlocked', '1'); else h.removeAttribute('data-tg-unlocked'); }
  }
  function clearOpt() { opt = null; if (optTimer) { clearTimeout(optTimer); optTimer = null; } check(); }
  function check() {
    var el = msgEl();
    var t = el ? realText(el) : '';
    var disc = discApplied();
    if (opt) {
      if (disc) { log('server confirmed (discount row)'); opt = null; if (optTimer) { clearTimeout(optTimer); optTimer = null; } }
      else if (el && t && t !== opt.from && !opt.answered) { opt.answered = Date.now(); setTimeout(check, 900); } /* server text landed; give the Savings row a moment */
      else if (opt.answered && Date.now() - opt.answered >= 850) { log('server says not unlocked -> revert'); opt = null; if (optTimer) { clearTimeout(optTimer); optTimer = null; } }
    }
    try { /* zh: flag when every Savings tag is the automatic "10% off $120" so CSS can show it as 满$120享9折 (discount itself untouched) */
      var tg = document.querySelectorAll('[data-essential-cart-element="discount-code-tag"]'), all120 = tg.length > 0;
      for (var z = 0; z < tg.length; z++) if (!/^\s*10%\s*off\s*\$120\s*$/i.test(tg[z].textContent || '')) all120 = false;
      var hh = document.documentElement;
      if (all120 !== hh.hasAttribute('data-tg-tag120')) { if (all120) hh.setAttribute('data-tg-tag120', ''); else hh.removeAttribute('data-tg-tag120'); }
    } catch (ez) {}
    var un = !!opt || disc || (el && isUnlocked(t));
    setUnlocked(un);
    if (!el) { lastState = null; return; }
    if (lastState === false && un) rain();
    lastState = un;
  }
  var lastBtn = null, lastAt = 0;
  function onClick(e) {
    try {
      if (e.type === 'click' && e.detail === 0) { /* keyboard activation: allowed */ } else if (e.type === 'pointerdown' && e.button !== 0) return;
      var btn = e.target && e.target.closest && e.target.closest('[data-essential-cart-element="quantity-increment"], [data-essential-cart-element="upsell-add-to-cart-button"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (btn === lastBtn && Date.now() - lastAt < 700) return; /* dedupe pointerdown + click */
      lastBtn = btn; lastAt = Date.now();
      var el = msgEl(); if (!el) return;
      var t = realText(el);
      log('press', btn.getAttribute('data-essential-cart-element'), JSON.stringify(t));
      if (opt || document.documentElement.hasAttribute('data-tg-unlocked') || isUnlocked(t) || !/more|spend|add|再消费|再消費|还差|即可/i.test(t)) return;
      var need = money(t); if (need.length !== 1 || !(need[0] > 0)) return;
      var unit = NaN;
      if (btn.getAttribute('data-essential-cart-element') === 'quantity-increment') {
        var li = btn.closest('[data-essential-cart-element="cart-drawer-item"]'); if (!li) return;
        var pe = q('[data-essential-cart-element="line-item-price"]', li), qe = q('[data-essential-cart-element="quantity-value"]', li);
        var p = pe ? money(pe.textContent) : [];
        var qty = qe ? parseInt(qe.value != null && qe.value !== '' ? qe.value : qe.textContent, 10) : NaN;
        log('line', p, qty);
        if (!p.length || !(qty > 0)) return;
        unit = Math.min.apply(null, p) / qty;
      } else {
        var up = btn.closest('[data-essential-cart-element="upsell-product"]'); if (!up) return;
        var pp = []; up.querySelectorAll('[data-essential-cart-element="upsell-price"], [data-essential-cart-element="upsell-discounted-price"], [data-essential-cart-element="upsell-regular-price"]').forEach(function (x) { pp = pp.concat(money(x.textContent)); });
        if (!pp.length) return;
        unit = Math.min.apply(null, pp);
      }
      log('need', need[0], 'unit', unit);
      if (!(unit > 0) || need[0] > unit + 0.001) return;
      try { /* copy the app's real pill text font onto our overlay so nothing changes when the server text lands */
        var sp = el.querySelector('[data-essential-cart-element="reward-progress-text-content"] span') || el.querySelector('[data-essential-cart-element="reward-progress-text-content"]') || el;
        var cs = getComputedStyle(sp);
        ['fontFamily','fontSize','fontWeight','fontStyle','letterSpacing','lineHeight'].forEach(function (k) { el.style.setProperty('--tg-o-' + k, cs[k]); });
      } catch (e2) {}
      opt = { from: t, at: Date.now(), answered: 0 };
      setUnlocked(true);
      lastState = true;
      log('optimistic on');
      rain();
      optTimer = setTimeout(clearOpt, 8000); /* safety: never leave our text if the server never answers */
    } catch (err) { /* never break the cart */ }
  }
  function init() {
    document.addEventListener('pointerdown', onClick, true);
    document.addEventListener('click', onClick, true);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; check(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    check(); /* sets initial state silently (no rain on load) */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* v6: turkey milestone rides the leading edge of the reward fill (Essential Cart sets --width:% inline on the fill) */
(function () {
  var q = false;
  function place() {
    q = false;
    var fills = document.querySelectorAll('[data-essential-cart-element="reward-progress-bar-fill"]');
    for (var i = 0; i < fills.length; i++) {
      var f = fills[i], bar = f.closest('[data-essential-cart-element="reward-progress-bar"]'), tr = f.parentElement;
      if (!bar || !tr) continue;
      var m = /--width:\s*([\d.]+)%/.exec(f.getAttribute('style') || ''), pct = m ? parseFloat(m[1]) : 0;
      if (document.documentElement.hasAttribute('data-tg-unlocked')) pct = 100;
      pct = Math.max(0, Math.min(100, pct));
      var dx = ((pct / 100) - 1) * tr.getBoundingClientRect().width;
      var v = dx.toFixed(1) + 'px';
      if (bar.style.getPropertyValue('--tg-dx') !== v) bar.style.setProperty('--tg-dx', v);
    }
  }
  function sched() { if (!q) { q = true; requestAnimationFrame(place); } }
  function go() {
    new MutationObserver(sched).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-tg-unlocked'] });
    window.addEventListener('resize', sched); sched();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* v6.54 Shop "Follow / Following on Shop" button: white label on the burgundy footer.
   The button is a web component with its own (open) shadow DOM and no ::part/CSS variables, so theme CSS cannot reach it;
   inject a tiny style into its shadow root. Label text + Shop wordmark only; the heart icon and purple pill are left as Shop draws them. */
(function () {
  var CSS = 'button > span, button > span *{color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;fill:currentColor}';
  function fix() {
    document.querySelectorAll('shop-follow-button').forEach(function (el) {
      var r = el.shadowRoot; if (!r || r.querySelector('style[data-tg-white]')) return;
      var s = document.createElement('style'); s.setAttribute('data-tg-white', ''); s.textContent = CSS; r.appendChild(s);
    });
  }
  var n = 0, t = setInterval(function () { fix(); if (++n > 40) clearInterval(t); }, 500);
  if (window.MutationObserver) new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();
